import { c as _c } from "react/compiler-runtime";
import CarouselComponent, { CarouselType } from '@spa/components/carousel/carousel.component';
import { Fragment, ReactElement, memo } from 'react';
import MobileIconTile, { Icon } from '@spa/components/mobile-icon-tile/mobile-icon-tile.component';
import ConfigurableCmsComponentMetadata from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-component-metadata.component';
import ConfigurableCmsSlotMetadata from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-slot-metadata.component';
import ConfigurableCmsValidity from '@spa/top-level-components/cms-page/metadata/configurable/configurable-cms-validity.component';
import HeadlineComponent from '@spa/components/headline/headline.component';
import LayoutVariant from '@spa/components/mobile-icon-carousel/layout-variant';
import { LinkComponentLink } from '@spa/components/link/link.component';
import { Metadata } from '@spa/pages-converters/cms/component-envelops/CmsComponentEnvelopBase';
import classNames from 'clsx';
import styles from './mobile-icon-carousel.component.module.scss';
interface MobileIconTile {
  readonly icon: Icon;
  readonly dateFrom: number | null;
  readonly dateTo: number | null;
  readonly link: LinkComponentLink | null;
  readonly text: string | null;
  readonly metadata: ReadonlyArray<Metadata>;
}
export interface Props {
  readonly id: string;
  readonly editorMode: boolean;
  readonly dateFrom: number | null;
  readonly dateTo: number | null;
  readonly headline: string | null;
  readonly headlineLink: LinkComponentLink | null;
  readonly icons: ReadonlyArray<MobileIconTile>;
  readonly iconsMetadata: ReadonlyArray<Metadata>;
  readonly metadata: ReadonlyArray<Metadata>;
  readonly subHeadline: string | null;
  readonly layoutVariant: LayoutVariant;
  readonly priority: boolean;
}
function getMobileIconCarouselItemKey(icon: Icon, link: LinkComponentLink | null, text: string | null, iconIdx: number): string {
  return [text ?? 'no-text', link?.type ?? 'no-link', icon.src, iconIdx].join(':');
}
function MobileIconCarousel(t0) {
  const $ = _c(38);
  const {
    id,
    editorMode,
    headline,
    headlineLink,
    icons,
    iconsMetadata,
    subHeadline,
    dateFrom,
    dateTo,
    layoutVariant,
    priority
  } = t0;
  let t1;
  if ($[0] !== editorMode) {
    t1 = classNames(styles["mobile-icon-carousel"], {
      [styles["mobile-icon-carousel--editor-mode"]]: editorMode
    });
    $[0] = editorMode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dateFrom || $[3] !== dateTo || $[4] !== editorMode) {
    t2 = editorMode && <ConfigurableCmsValidity dateFrom={dateFrom} dateTo={dateTo} />;
    $[2] = dateFrom;
    $[3] = dateTo;
    $[4] = editorMode;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== headline || $[7] !== headlineLink || $[8] !== id || $[9] !== subHeadline) {
    t3 = headline && <HeadlineComponent id={`${id}-headline`} headline={headline} link={headlineLink} subHeadline={subHeadline} headlineTag="h2" />;
    $[6] = headline;
    $[7] = headlineLink;
    $[8] = id;
    $[9] = subHeadline;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== editorMode || $[12] !== iconsMetadata) {
    t4 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={true} metadata={iconsMetadata} />;
    $[11] = editorMode;
    $[12] = iconsMetadata;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = `${id}-carousel`;
  let t6;
  if ($[14] !== editorMode || $[15] !== icons || $[16] !== layoutVariant || $[17] !== priority) {
    let t7;
    if ($[19] !== editorMode || $[20] !== layoutVariant || $[21] !== priority) {
      t7 = (t8, iconIdx) => {
        const {
          icon,
          link,
          text,
          metadata,
          dateFrom: dateFrom_0,
          dateTo: dateTo_0
        } = t8;
        return <Fragment key={getMobileIconCarouselItemKey(icon, link, text, iconIdx)}>{editorMode && <><ConfigurableCmsComponentMetadata beforeComponent={true} metadata={metadata} /><ConfigurableCmsValidity dateFrom={dateFrom_0} dateTo={dateTo_0} /></>}<MobileIconTile icon={icon} link={link} text={text} metadata={metadata} layoutVariant={layoutVariant} priority={priority && iconIdx < 4} />{editorMode && <ConfigurableCmsComponentMetadata beforeComponent={false} metadata={metadata} />}</Fragment>;
      };
      $[19] = editorMode;
      $[20] = layoutVariant;
      $[21] = priority;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t6 = icons.map(t7);
    $[14] = editorMode;
    $[15] = icons;
    $[16] = layoutVariant;
    $[17] = priority;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[23] !== t5 || $[24] !== t6) {
    t7 = <CarouselComponent id={t5} carouselType={CarouselType.MOBILE_ICON}>{t6}</CarouselComponent>;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== editorMode || $[27] !== iconsMetadata) {
    t8 = editorMode && <ConfigurableCmsSlotMetadata beforeSlot={false} metadata={iconsMetadata} />;
    $[26] = editorMode;
    $[27] = iconsMetadata;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t4 || $[30] !== t7 || $[31] !== t8) {
    t9 = <div>{t4}{t7}{t8}</div>;
    $[29] = t4;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t1 || $[34] !== t2 || $[35] !== t3 || $[36] !== t9) {
    t10 = <div className={t1}>{t2}{t3}{t9}</div>;
    $[33] = t1;
    $[34] = t2;
    $[35] = t3;
    $[36] = t9;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  return t10;
}
export default memo(MobileIconCarousel);